import { Component } from '@angular/core';

@Component({
    selector: 'app-contact-protekta',
    templateUrl: './contact-protekta.component.html',
    styleUrls: ['./contact-protekta.component.scss'],
    standalone: false,
})
export class ContactProtektaComponent {
    contact = contactProtektaBern;

    constructor() {
        contactProtektaBern.organisationUnit.webpages.webpage = protektaKontaktFormularDe;
        contactProtektaNyon.organisationUnit.webpages.webpage = protektaKontaktFormularFr;
    }

    handleValueChange(value: string) {
        if (value === 'bern') {
            this.contact = contactProtektaBern;
        } else {
            this.contact = contactProtektaNyon;
        }
    }
}

const protektaEmail = 'info@protekta.ch';

const protektaKontaktFormularDe = 'https://protekta.mobiliar.ch/kontakt/kontaktformular';
const protektaKontaktFormularFr = 'https://protekta.mobiliere.ch/contact/formulaire-de-contact';

const protektaBern = 'Protekta Rechtsschutz-Versicherung AG';
const protektaBernAdress = {
    street: 'Monbijoustrasse 5',
    postalCode: '3011',
    location: 'Bern',
};

export const contactProtektaBern = {
    organisationUnit: {
        names: {
            name: protektaBern,
            de: protektaBern,
            fr: protektaBern,
            it: protektaBern,
        },
        addresses: {
            de: protektaBernAdress,
            fr: protektaBernAdress,
            it: protektaBernAdress,
            address: protektaBernAdress,
        },
        phone: '+41 31 389 85 00',
        webpages: {
            de: protektaKontaktFormularDe,
            it: 'https://www.protekta.ch/it/assistenza-giuridica-e-richieste/modulo-di-contatto',
            fr: 'https://www.protekta.ch/fr/comment-pouvez-nous-vous-aider',
            webpage: protektaKontaktFormularDe,
        },
        emails: {
            de: protektaEmail,
            it: protektaEmail,
            fr: protektaEmail,
            email: protektaEmail,
        },
        geoLocation: {
            lat: 46.94528083355329,
            lng: 7.437180806617565,
        },
    },
    openinghours: {
        morning: '08:00 - 12:00',
        afternoon: '13:30 - 17:00',
    },
    subtitle: 'osm.footer.protekta.contact.subtitle.bern',
};

const protektaNyon = 'Protekta Assurance de protection jurdique SA';
const protektaNyonAdress = {
    street: 'Chemin de la Redoute 54',
    postalCode: '1260',
    location: 'Nyon',
};

export const contactProtektaNyon = {
    organisationUnit: {
        names: {
            name: protektaNyon,
            de: protektaNyon,
            fr: protektaNyon,
            it: protektaNyon,
        },
        addresses: {
            de: protektaNyonAdress,
            fr: protektaNyonAdress,
            it: protektaNyonAdress,
            address: protektaNyonAdress,
        },
        phone: '+41 31 389 85 00',
        webpages: {
            de: protektaKontaktFormularDe,
            it: 'https://www.protekta.ch/it/assistenza-giuridica-e-richieste/modulo-di-contatto',
            fr: 'https://www.protekta.ch/fr/rechtshilfe-anliegen/kontaktformular',
            webpage: protektaKontaktFormularFr,
        },
        emails: {
            de: protektaEmail,
            it: protektaEmail,
            fr: protektaEmail,
            email: protektaEmail,
        },
        geoLocation: {
            lat: 46.38946704847963,
            lng: 6.241560007611827,
        },
    },
    openinghours: {
        morning: '08:00 - 12:00',
        afternoon: '13:30 - 16:45',
    },
    subtitle: 'osm.footer.protekta.contact.subtitle.nyon',
};
